<template>
  <a-drawer
    :title="title"
    width="60%"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="hide"
  >
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="统计单号">{{ detailData.statNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="归档统计单ID">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="归档存储状态">
            <a-tag :color="getArchiveStorageClassColor(detailData.archiveStorageClass)">
              {{ getArchiveStorageClassText(detailData.archiveStorageClass) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="存储续费类型">
            <a-tag :color="getRenewTypeColor(detailData.renewType)">
              {{ getRenewTypeText(detailData.renewType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="归档到期时间">{{ formatTime(detailData.expireTime) || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="容量信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="归档总容量">
            <span class="capacity-text">{{ $formatCapacity(detailData.totalArchiveCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="归档场景数量">
            <span>{{ detailData.archiveSceneCount || 0 }} 个场景</span>
          </a-descriptions-item>
          <a-descriptions-item label="续费金额">
            <span v-if="detailData.renewAmount" class="price-text">¥{{ detailData.renewAmount }}</span>
            <span v-else>-</span>
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="getStatusColor(detailData.status)">
              {{ getStatusText(detailData.status) }}
            </a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="来源信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="来源存储池ID">{{ detailData.sourcePoolId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="来源存储类型">
            <a-tag :color="getSourceTypeColor(detailData.renewType)">
              {{ getSourceTypeText(detailData.renewType) }}
            </a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="备注信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">{{ detailData.remark || '-' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getArchiveDetail } from '@/api/VR/storage'
import { message } from 'ant-design-vue'

export default {
  name: 'ArchiveDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
      archiveStorageClassMap: {
        0: '标准',
        1: '低频',
        2: '深度',
      },
      archiveStorageClassColorMap: {
        0: 'blue',
        1: 'green',
        2: 'orange',
      },
      renewTypeMap: {
        0: '标准',
        1: '安心存储',
        2: '灵活存储',
      },
      renewTypeColorMap: {
        0: 'blue',
        1: 'green',
        2: 'orange',
      },
      statusMap: {
        0: '正常',
        1: '失效',
        2: '数据删除',
      },
      statusColorMap: {
        0: 'green',
        1: 'red',
        2: 'gray',
      },
      sourceTypeMap: {
        1: '安心存储',
        2: '灵活存储',
      },
      sourceTypeColorMap: {
        1: 'blue',
        2: 'purple',
      },
    }
  },
  computed: {
    title() {
      return `归档存储详情`
    },
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getArchiveDetail({ id })
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取归档详情失败')
        }
      } catch (error) {
        console.error('获取归档详情失败:', error)
        message.error('获取归档详情失败')
      } finally {
        this.loading = false
      }
    },

    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleDateString()
    },
    getArchiveStorageClassText(type) {
      return this.archiveStorageClassMap[type] || '-'
    },
    getArchiveStorageClassColor(type) {
      return this.archiveStorageClassColorMap[type] || 'default'
    },
    getRenewTypeText(type) {
      return this.renewTypeMap[type] || '-'
    },
    getRenewTypeColor(type) {
      return this.renewTypeColorMap[type] || 'default'
    },
    getStatusText(status) {
      return this.statusMap[status] || '-'
    },
    getStatusColor(status) {
      return this.statusColorMap[status] || 'default'
    },
    getSourceTypeText(type) {
      return this.sourceTypeMap[type] || '-'
    },
    getSourceTypeColor(type) {
      return this.sourceTypeColorMap[type] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.capacity-text {
  font-weight: 600;
  color: #1890ff;
}

.price-text {
  font-weight: 600;
  color: #52c41a;
}

.ant-descriptions {
  margin-bottom: 0;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card:last-child {
  margin-bottom: 0;
}
</style>
